let state = {
  brandStores:[]
  //loyaltypoints: undefined,
}
export default state


// WEBPACK FOOTER //
// ./src/store/shopWithBrands/state.js